import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import Card from '../common/Card';
import './Settings.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    platformName: 'Marilink',
    supportEmail: 'support@marilink.com',
    currency: 'USD',
    timezone: 'UTC+04:00',
    platformFee: 5,
    escrowFee: 2.5,
    minFee: 50,
    emailNotifications: true,
    twoFactorAuth: false,
    maintenanceMode: false
  });

  const getToken = () => localStorage.getItem('marilink_token');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/admin/settings`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setSettings(data.settings);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/admin/settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        alert('Settings saved successfully');
      } else {
        alert(data.message);
      }
    } catch (error) {
      alert('Error saving settings: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  if (loading) return <div className="loading-spinner">Loading settings...</div>;

  return (
    <div className="admin-settings-page">
      <div className="page-header">
        <h1><i className="fas fa-cog"></i> Platform Settings</h1>
        <p>Configure platform-wide settings and preferences</p>
      </div>

      <div className="settings-tabs">
        <button className={`tab-btn ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}>General</button>
        <button className={`tab-btn ${activeTab === 'fees' ? 'active' : ''}`} onClick={() => setActiveTab('fees')}>Fees & Commissions</button>
        <button className={`tab-btn ${activeTab === 'security' ? 'active' : ''}`} onClick={() => setActiveTab('security')}>Security</button>
      </div>

      <div className="settings-content">
        {activeTab === 'general' && (
          <Card title="General Settings">
            <div className="form-group"><label>Platform Name</label><input type="text" value={settings.platformName} onChange={(e) => handleChange('platformName', e.target.value)} /></div>
            <div className="form-group"><label>Support Email</label><input type="email" value={settings.supportEmail} onChange={(e) => handleChange('supportEmail', e.target.value)} /></div>
            <div className="form-group"><label>Currency</label><select value={settings.currency} onChange={(e) => handleChange('currency', e.target.value)}><option value="USD">USD</option><option value="AED">AED</option><option value="EUR">EUR</option></select></div>
            <div className="form-group"><label>Time Zone</label><select value={settings.timezone} onChange={(e) => handleChange('timezone', e.target.value)}><option value="UTC+04:00">Dubai (UTC+4)</option><option value="UTC+08:00">Singapore (UTC+8)</option><option value="UTC+00:00">London (UTC+0)</option></select></div>
          </Card>
        )}

        {activeTab === 'fees' && (
          <Card title="Fees & Commissions">
            <div className="form-group"><label>Platform Fee (%)</label><input type="number" value={settings.platformFee} onChange={(e) => handleChange('platformFee', e.target.value)} /></div>
            <div className="form-group"><label>Escrow Fee (%)</label><input type="number" value={settings.escrowFee} onChange={(e) => handleChange('escrowFee', e.target.value)} /></div>
            <div className="form-group"><label>Minimum Fee (USD)</label><input type="number" value={settings.minFee} onChange={(e) => handleChange('minFee', e.target.value)} /></div>
          </Card>
        )}

        {activeTab === 'security' && (
          <Card title="Security Settings">
            <label className="checkbox-label"><input type="checkbox" checked={settings.emailNotifications} onChange={(e) => handleChange('emailNotifications', e.target.checked)} /> Email Notifications</label>
            <label className="checkbox-label"><input type="checkbox" checked={settings.twoFactorAuth} onChange={(e) => handleChange('twoFactorAuth', e.target.checked)} /> Two-Factor Authentication</label>
            <label className="checkbox-label"><input type="checkbox" checked={settings.maintenanceMode} onChange={(e) => handleChange('maintenanceMode', e.target.checked)} /> Maintenance Mode</label>
          </Card>
        )}
      </div>

      <div className="save-actions">
        <Button variant="primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</Button>
      </div>
    </div>
  );
};

export default Settings;